import { getImage } from "./imageConstants"

const pageData = {
    pages: {
        iosPage: {
            title: 'IOS APPS',
            description: 'We develop custom IOS application to propel your business forward, carefully managing each stage from concept to launch.',
            ReliabilityIOSData: [
                {
                    key: 1,
                    image: getImage('Idea'),
                    title: 'Idea Development',
                    subtitle: 'Your concept begins to form.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 2,
                    image: getImage('USER'),
                    title: 'User-centered design',
                    subtitle: 'Emphasize the experience for users.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('THOROUGH'),
                    title: 'Thorough testing',
                    subtitle: 'Emphasize the experience for users.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('PROGRAM'),
                    title: 'Strong programming',
                    subtitle: 'Create dependable and scalable code.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 5,
                    image: getImage('PROTOTYPE'),
                    title: 'Quick prototyping',
                    subtitle: 'Develop prototypes effciently.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 6,
                    image: getImage('SWIFT'),
                    title: 'Swift release',
                    subtitle: 'Launch quickly on the App Store.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
            ],
            IOSIdeaProjectsData: [
                {
                    key: 1,
                    image: getImage('IDEAAVATAR'),
                    title: 'Idea & Plan',
                    subtitle: 'We work with you develop a strategy aligned with your business goals by understanding your vision, target audience, & essential app features. This foundational step ensures a clear plan for a successful app, with every decision supporting your objectives.',
                    row: 'flex-col md:flex-row',
                    justify: 'justify-center md:justify-center',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
                {
                    key: 2,
                    image: getImage('PROTOTYPING'),
                    title: 'Design & Prototyping',
                    subtitle: 'Our UI/UX designers turn your concepts into a visually attractive and easy-to-use interface. We develop interactive prototypes to help you understand how the app will function and what it will feel like.',
                    row: 'flex-col md:flex-row-reverse',
                    justify: 'justify-center md:justify-center',
                    text: 'end',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('DEVELOPMENT'),
                    title: 'Development',
                    subtitle: 'Our skilled developers build a powerful, flexible app using the latest technologies, providing regular updates throughout rapid development cycles.',
                    row: 'flex-col md:flex-row',
                    justify: 'justify-center md:justify-center',
                    text: 'left',
                    textColor: 'purple',
                    color: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('OPTIMIZATION'),
                    title: 'Testing & Optimization',
                    subtitle: 'We start our quality assurance process while developing the app. We perform detailed tests to make sure the app is free of bugs, loads fast, and adheres to top security standards.',
                    row: 'flex-col md:flex-row-reverse',
                    justify: 'justify-center md:justify-center',
                    text: 'end',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('LAUNCH'),
                    title: 'Launch & Support',
                    subtitle: 'When your app is ready to launch, we help with App Store submission and offer ongoing support, including updates, bug fixes, and improvements for compatibility with the latest iOS versions.Count on us for continuous support to keep your app running smoothly.',
                    row: 'flex-col md:flex-row',
                    justify: 'justify-center md:justify-center',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
            ],
        },

        androidPage: {
            title: 'Android apps',
            description: 'Designed for adaptability and growth, our apps work seamlessly on all Android devices, whether for customer engagement or internal operations, to help you achieve your goals.',
            ReliabilityAndroidData: [
                {
                    key: 1,
                    image: getImage('SKILLS'),
                    title: 'Capacity to expand',
                    subtitle: 'Your application adapt & grows smoothly with your business needs.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 2,
                    image: getImage('DESIGN'),
                    title: 'Design that puts users first',
                    subtitle: 'Always straightforward and focused on giving a first rate experience.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('LOGIN'),
                    title: 'Easy access for everyone',
                    subtitle: 'Reach a broad audience across diverse android device.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('SECURITY'),
                    title: 'Security',
                    subtitle: 'Your information is protected by the most up to date security standards.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('PERSONALIZATION'),
                    title: 'Personalization',
                    subtitle: 'Add your personal touch to the app with your chosen features.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
            ],
            AndroidIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Idea & Strategy',
                    subtitle: 'We begin with a detailed conversation to understand your ideas and create a strategy that suits your vision. Every project starts with a firm foundation, where we outline the specific goals, features, and audience for your app.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & UI/UX',
                    subtitle: 'Our UI/UX designers bring your vision to life with a design that is appealing and easy to navigate. This design focuses on creating a smooth user experience that increases your brand’s value.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'end',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('EXECUTION'),
                    title: 'Development & Execution',
                    subtitle: 'We develop the app to be both efficient and durable, ensuring it can adapt as your business evolves. Our developers prioritize optimization of your app for various Android devices.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'purple',
                    color: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('REFINING'),
                    title: 'Checking & Refining',
                    subtitle: 'We begin with a detailed conversation to understand your ideas and create a strategy that suits your vision. Every project starts with a firm foundation, where we outline the specific goals, features, and audience for your app.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'end',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('ANDROIDSTRATEGY'),
                    title: 'Idea & Strategy',
                    subtitle: 'We begin with a detailed conversation to understand your ideas and create a strategy that suits your vision. Every project starts with a firm foundation, where we outline the specific goals, features, and audience for your app.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
            ],
            AndroidFeaturesList: [
                {
                    key: 1,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Support for different Android devices",
                    description: "Our apps perform without issues on various devices."
                },
                {
                    key: 2,
                    arrowColor: "#98FF12",
                    textColor: "green",
                    title: "Scalable solutions",
                    description: "Structured to grow with your business."
                },
                {
                    key: 3,
                    arrowColor: "#842CFF",
                    textColor: "purple",
                    title: "Security is our top priority",
                    description: "Your information is always secure thanks to our use of the latest security technology."
                },
                {
                    key: 4,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Support for different Android devices",
                    description: "Our apps perform without issues on various devices."
                },
                {
                    key: 5,
                    arrowColor: "#98FF12",
                    textColor: "green",
                    title: "Scalable solutions",
                    description: "Structured to grow with your business."
                },
                {
                    key: 6,
                    arrowColor: "#842CFF",
                    textColor: "purple",
                    title: "Security is our top priority",
                    description: "Your information is always secure thanks to our use of the latest security technology."
                },
                {
                    key: 7,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Support for different Android devices",
                    description: "Our apps perform without issues on various devices."
                },


            ],
        },

        enterprisePage: {
            title: 'Enterprise Apps',
            description: 'We build tailored enterprise applications that enhance operational efficiency, increase productivity, and facilitate growth for large organizations, guaranteeing smooth integration and scalability for the future.',
            ReliabilityEnterpriseData: [
                {
                    key: 1,
                    image: getImage('MASKGROUP'),
                    title: 'Optimized operations',
                    subtitle: 'Make processes automatic and simplify workflows.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 2,
                    image: getImage('INTEGRATION'),
                    title: 'Easy integration',
                    subtitle: 'Our applications connect easily with existing systems to maintain seamless operations.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('SECURITYENTER'),
                    title: 'Data security',
                    subtitle: 'Built with strong security to protect sensitive information.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('SCALABILITY'),
                    title: 'Allow scalability',
                    subtitle: 'Developed to progress with your business, accommodating growing needs.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('DESIGNENTER'),
                    title: 'Design focused on users',
                    subtitle: 'Our focus is on achieving seamless interaction for both our internal groups and the external parties we engage with.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
            ],
            EnterPriseIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Research & Strategy',
                    subtitle: 'Our process starts with a thorough review of your business operations, challenges, and objectives. We work together to outline the features and functions that will ensure the app’s success in line with your business goals.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
                {
                    key: 2,
                    image: '',
                    title: 'Tailored design for your organization',
                    subtitle: 'The design team creates a straightforward interface that benefits both employees and customers. We prioritize usability and excellent performance.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('SOLIDDEV'),
                    title: 'Solid development',
                    subtitle: 'We build your app with the highest standards, ensuring it is stable, secure, and capable of managing large data and user volumes. You will receive regular updates to keep you informed about our progress.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'purple',
                    color: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('EVALUATION'),
                    title: 'Evaluation & Security',
                    subtitle: 'Prior to launch, we carry out detailed testing to confirm the app is without bugs and adheres to strict security requirements.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('ONGOING'),
                    title: 'Implementation & Ongoing support',
                    subtitle: 'After going live, we provide ongoing support with security updates and new features. This support helps keep your enterprise app working well as your business expands.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
            ],
            EnterpriseFeatures: [
                {
                    key: 1,
                    color: "yellow",
                    bgColor: "#FFB912",
                    title: "Live data analysis",
                    description: "Support your teams with the most recent analytics for effective, data-informed decisions."
                },
                {
                    key: 2,
                    color: "green",
                    bgColor: "#98FF12",
                    title: "Enhanced safety measures",
                    description: "Strong encryption and access control to protect your data."
                },
                {
                    key: 3,
                    color: "purple",
                    bgColor: "#842CFF",
                    title: "Customized workflow options",
                    description: "Design workflows to align with the particular needs of various teams and departments."
                },
                {
                    key: 4,
                    color: "green",
                    bgColor: "#98FF12",
                    title: "Support for multiple platforms",
                    description: "Our apps operate without issues on desktops, mobiles, & tablets, offering your workforce the freedom to work anywhere."
                },
                {
                    key: 5,
                    color: "yellow",
                    bgColor: "#FFB912",
                    title: "Integrating with the cloud",
                    description: "Leverage cloud services for secure and scalable data options"
                },
            ],
        },

        appSupportPage: {
            title: 'App support and version updates',
            description: 'Designed for adaptability and growth, our apps work seamlessly on all Android devices, whether for customer engagement or internal operations, to help you achieve your goals.',
            ReliabilityAppsSupportData: [
                {
                    key: 1,
                    image: getImage('SKILLS'),
                    title: 'Security updates',
                    subtitle: 'App maintenance and updates for performance and security.',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    fromColor: 'from-[#FFB91277]',
                },
                {
                    key: 2,
                    image: getImage('DESIGN'),
                    title: 'Bug fixes',
                    subtitle: 'Fast solutions to keep your app working without issues.',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green',
                    fromColor: 'from-[#98FF1277]',
                },
                {
                    key: 3,
                    image: getImage('LOGIN'),
                    title: 'Security updates',
                    subtitle: 'Verifies that your app works properly with the newest updates for iOS, Android, & other platforms.',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'purple',
                    fromColor: 'from-[#842CFF77]',
                },
                {
                    key: 4,
                    image: getImage('SECURITY'),
                    title: 'Performance optimization',
                    subtitle: "We track and enhance your app's performance to avoid any crashes or lags.",
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green',
                    fromColor: 'from-[#98FF1277]',
                },
                {
                    key: 5,
                    image: getImage('PERSONALIZATION'),
                    title: 'New features',
                    subtitle: 'Quickly introduce new features to meet the changing demands of your users and business.',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    fromColor: 'from-[#FFB91277]',
                },
            ],
        },

        customServicePage: {
            title: 'Custom software development services',
            description: 'Unlock the full potential of your business with our tailor- made software solutions. At SATTVA TECH, we design & develop custom software that aligns perfectly with your unique business processes and goals. Whether you need a complex enterprise application or a streamlined solution to automate your workflows, we build software that helps you innovate and grow.',
            ReliabilityServiceData: [
                {
                    key: 1,
                    title: 'Customized solutions',
                    subtitle: 'Your software is built specifically for your business processes, ensuring optimal functionality and efficiency.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    title: 'Enhanced scalability',
                    subtitle: 'Your software evolves as your business grows, with the ability to add new features and capabilities over time.',
                    color: 'green'
                },
                {
                    key: 3,
                    title: 'Improved efficiency',
                    subtitle: 'Automate repetitive tasks and streamline operations to save time and reduce errors.',
                    color: 'purple'
                },
                {
                    key: 4,
                    title: 'Flexible integration',
                    subtitle: 'Custom solutions integrate seamlessly with your existing systems and tools, enabling a smooth flow of data and operations.',
                    color: 'green'
                },
                {
                    key: 5,
                    title: 'Security & Compliance',
                    subtitle: 'Designed with industry-leading security measures, including compliance with GDPR, HIPAA, and other regulations.',
                    color: 'yellow'
                },
            ],
            ServiceIdeaProjectsData: [
                {
                    key: 1,
                    image: getImage('SERVICEDISCOVERY'),
                    title: 'Discovery & Strategy',
                    subtitle: 'Our process begins with a thorough understanding of your business needs and challenges. We work closely with you to define the scope of the project and identify the best technological solutions to achieve your goals.',
                    row: 'row',
                    justify: 'start',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912',
                    steps: [
                        {
                            key: 1,
                            title: 'Business analysis'
                        },
                        {
                            key: 2,
                            title: 'Requirement gathering'
                        },
                        {
                            key: 3,
                            title: 'Technology stack selection'
                        },
                        {
                            key: 4,
                            title: 'Strategic planning'
                        },
                    ]
                },
                {
                    key: 2,
                    image: getImage('SERVICEDESIGN'),
                    title: 'Design & Prototyping',
                    subtitle: 'Our design team creates a user-friendly and visually appealing interface that ensures your software is both functional and easy to navigate. We focus on designing intuitive experiences that drive engagement.',
                    row: 'row-reverse',
                    justify: 'end',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12',
                    steps: [
                        {
                            key: 1,
                            title: 'Wireframes and mockups'
                        },
                        {
                            key: 2,
                            title: 'Prototyping'
                        },
                        {
                            key: 3,
                            title: 'Responsive design'
                        },
                        {
                            key: 4,
                            title: 'User experience (UX)'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('SERVICEIMPLEMEN'),
                    title: 'Development & Implementation',
                    subtitle: 'In the development phase, we bring your software to life using cutting-edge technologies. Our agile development process ensures that you receive regular updates and have input throughout the project lifecycle.',
                    row: 'row',
                    justify: 'start',
                    text: 'left',
                    textColor: 'purple',
                    color: '#842CFF',
                    steps: [
                        {
                            key: 1,
                            title: 'Agile development'
                        },
                        {
                            key: 2,
                            title: 'Custom coding'
                        },
                        {
                            key: 3,
                            title: 'Integration'
                        },
                        {
                            key: 4,
                            title: 'Quality assurance'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('SERVICETESTING'),
                    title: 'Testing & Optimization',
                    subtitle: 'Before your software goes live, we perform rigorous testing to ensure it works perfectly. This includes functionality, performance, and security testing to deliver a flawless product.',
                    row: 'row-reverse',
                    justify: 'end',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12',
                    steps: [
                        {
                            key: 1,
                            title: 'Functional testing'
                        },
                        {
                            key: 2,
                            title: 'Performance testing'
                        },
                        {
                            key: 3,
                            title: 'Security testing'
                        },
                        {
                            key: 4,
                            title: 'User acceptance testing (UAT)'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('SERVICESUPPORT'),
                    title: 'Deployment & Support',
                    subtitle: 'Once the software is ready, we handle the deployment, ensuring a smooth transition. After the launch, we provide ongoing support to address any issues, make updates, and continue optimizing your software as your needs evolve.',
                    row: 'row',
                    justify: 'start',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912',
                    steps: [
                        {
                            key: 1,
                            title: 'Seamless deployment'
                        },
                        {
                            key: 2,
                            title: 'Ongoing support'
                        },
                        {
                            key: 3,
                            title: 'Future scalability'
                        },
                        {
                            key: 4,
                            title: 'Monitoring and maintenance'
                        },
                    ]
                },
            ],
            ServiceList: [
                {
                    key: 1,
                    arrowColor: "#FFB912",
                    bgColor: "to-[#ffb9123b]",
                    textColor: "yellow",
                    title: "Process automation",
                    list: [
                        {
                            key: 1,
                            title: 'Task automation'
                        },
                        {
                            key: 2,
                            title: 'Workflow management'
                        },
                        {
                            key: 3,
                            title: 'Data synchronization'
                        },
                        {
                            key: 4,
                            title: 'Custom reporting'
                        },
                    ]
                },
                {
                    key: 2,
                    arrowColor: "#98FF12",
                    bgColor: "to-[#98FF123b]",
                    textColor: "green",
                    title: "Data management & analytics",
                    desciprtion: "Structured to grow with your business.",
                    list: [
                        {
                            key: 1,
                            title: 'Centralized data management'
                        },
                        {
                            key: 2,
                            title: 'Advanced analytics'
                        },
                        {
                            key: 3,
                            title: 'Real-time dashboards'
                        },
                        {
                            key: 4,
                            title: 'Data security'
                        },
                    ]
                },
                {
                    key: 3,
                    arrowColor: "#842CFF",
                    bgColor: "to-[#842CFF3b]",
                    textColor: "purple",
                    title: "Security and compliance",
                    desciprtion: "Your information is always secure thanks to our use of the latest security technology.",
                    list: [
                        {
                            key: 1,
                            title: 'End-to-end encryption'
                        },
                        {
                            key: 2,
                            title: 'Access controls'
                        },
                        {
                            key: 3,
                            title: 'Compliance features'
                        },
                        {
                            key: 4,
                            title: 'Audit'
                        },
                    ]
                },
                {
                    key: 4,
                    arrowColor: "#FFB912",
                    bgColor: "to-[#ffb9123b]",
                    textColor: "yellow",
                    title: "API integrations",
                    list: [
                        {
                            key: 1,
                            title: 'Third-party integrations'
                        },
                        {
                            key: 2,
                            title: 'Custom API development'
                        },
                        {
                            key: 3,
                            title: 'Payment integrations'
                        },
                        {
                            key: 4,
                            title: 'Data import/export'
                        },
                    ]
                },
            ],
        },

        healthCarePage: {
            title: 'Healthcare App',
            description: 'Revolutionize patient care and improve healthcare operations with tailored apps for hospitals and clinics. SATTVA TECH develops state-of-the-art healthcare applications that enhance patient engagement & workflows while ensuring compliance.',
            ReliabilityHealthcareData: [
                {
                    key: 1,
                    title: 'Solutions that center around the patient',
                    subtitle: 'Applications created to enhance patient involvement, appointment setting, and care coordination.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    title: 'Secure and compliant',
                    subtitle: 'Every app is built in line with healthcare standards like HIPAA and GDPR, ensuring maximum data protection.',
                    color: 'green'
                },
                {
                    key: 3,
                    title: 'Better workflows',
                    subtitle: 'Simplify tasks like setting appointments, managing patient records, and handling billing.',
                    color: 'purple'
                },
                {
                    key: 4,
                    title: 'Merging telemedicine with medical services',
                    subtitle: 'Supply remote medical care and consultations via protected telemedicine platforms.',
                    color: 'green'
                },
                {
                    key: 5,
                    title: 'Real-time data',
                    subtitle: 'Use live patient data and insights to make fast, smart decisions.',
                    color: 'yellow'
                },
            ],
            HealthcareIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Planning',
                    subtitle: 'We begin by looking at the needs and goals of your health care facility. Our team collaborates with you to grasp the workflows, patient care issues, and regulations that are unique to your organization.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Needs assessment'
                        },
                        {
                            key: 2,
                            title: 'Regulatory analysis'
                        },
                        {
                            key: 3,
                            title: 'Technical planning'
                        },
                        {
                            key: 4,
                            title: 'Project roadmap'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & Prototyping',
                    subtitle: 'We have a design team that makes a simple and safe interface for healthcare providers and patients. Our goal is to create intuitive apps that give users a great experience while also being very secure.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'Wireframes and mockups'
                        },
                        {
                            key: 2,
                            title: 'Prototyping'
                        },
                        {
                            key: 3,
                            title: 'Responsive design'
                        },
                        {
                            key: 4,
                            title: 'User experience (UX) focus'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HEALTHDEV'),
                    title: 'Development & Implementation',
                    subtitle: 'We develop your healthcare app using secure and scalable tech.Key features like patient portals, telemedicine services, and EHR systems are included for easy operation.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    steps: [
                        {
                            key: 1,
                            title: 'Secure coding'
                        },
                        {
                            key: 2,
                            title: 'API integrations'
                        },
                        {
                            key: 3,
                            title: 'Telemedicine platforms'
                        },
                        {
                            key: 4,
                            title: 'Data encryption'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HEALTHTESTING'),
                    title: 'Testing & Compliance',
                    subtitle: 'Prior to launching, we conduct extensive tests on the app to guarantee it meets high standards for security, usability, and regulatory compliance. This includes checking its functionality, performance, and security.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'HIPAA compliance testing'
                        },
                        {
                            key: 2,
                            title: 'Functionality testing'
                        },
                        {
                            key: 3,
                            title: 'Performance testing'
                        },
                        {
                            key: 4,
                            title: 'User acceptance testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HEALTHONGOING'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'When testing finishes, we take care of deploying your healthcare app and provide ongoing assistance to keep it safe, current, and fully optimized.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Support and training'
                        },
                        {
                            key: 2,
                            title: 'Future scalability'
                        },
                        {
                            key: 3,
                            title: 'Compliance monitoring'
                        },
                    ]
                },
            ],
            HealthCareFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
            ],
        },

        aiBusinessPage: {
            title: 'AI For Businesses',
            description: 'Move your business forward with smart automation.',
            ReliabilityAiBusinessesData: [
                {
                    key: 1,
                    title: 'Maximize performance',
                    subtitle: 'Improve productivity by automating everyday tasks, allowing your team to prioritize essentials. AI technology simplifies operations for smarter work.',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow'
                },
                {
                    key: 2,
                    title: 'Optimized automation',
                    subtitle: "A business's power is in its ability to evolve and automate. AI systems optimize workflows, eliminate errors, and ensure smooth operations. Our solutions handle everything from customer service chatbots to backend tasks.",
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green'
                },
                {
                    key: 3,
                    title: 'Choices backed by data',
                    subtitle: 'Employ AI to analyze significant data and create actionable insights. This supports quicker and more precise decision-making, allowing your business to remain competitive.',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'purple'
                },
            ],
            AiBusinessesIdeaProjectsData: [
                {
                    key: 1,
                    image: getImage('IDEAAVATAR'),
                    title: 'Adapt to the future',
                    subtitle: 'Our AI solutions ensure your business is future-ready, with the ability to adapt and grow. AI offers the flexibility and scalability needed to meet your goals, whether expanding or facing challenges. With AI analytics, monitor performance in real time, anticipate trends, & instantly adjust strategies, working smarter.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
                {
                    key: 2,
                    image: getImage('PROTOTYPING'),
                    title: 'Optimized for all platforms',
                    subtitle: 'Our AI solutions are built to function on all devices, allowing your team to work together easily on desktop, mobile, or tablet. They are fully optimized to fit into your current systems, providing smooth workflows no matter where your team is.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 3,
                    image: getImage('SOLIDDEV'),
                    title: 'Centralized data management',
                    subtitle: 'Using AI for content management means your data is organized and processed automatically, which helps you access valuable insights easily. AI simplifies data management in CRMs and documents, allowing authorized personnel to get information with a simple click.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                },
                {
                    key: 4,
                    image: getImage('EVALUATION'),
                    title: 'Our AI solutions',
                    subtitle: 'We offer unique AI solutions made specifically for your business, recognizing that no two organizations are alike. Our dedicated team conducts in-depth research and analysis to develop solutions that reflect your brand identity and operational goals, providing you with tools that are as distinctive as your business itself.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                },
            ],
        },

        aiHealthcarePage: {
            title: 'AI for healthcare',
            description: 'Changing the future of healthcare with AI',
            ReliabilityAiHealthData: [
                {
                    key: 1,
                    title: 'Elevate patient care by implementing AI technology',
                    subtitle: 'AI technology supports medical staff by improving patient care through data insights. It analyzes patient information in real-time, facilitating quicker and smarter decisions for diagnoses, health risk identification, and customized treatment plans, ensuring appropriate care for every patient.',
                    color: 'yellow',
                },
                {
                    key: 2,
                    title: 'Elevate patient care by implementing AI technology',
                    subtitle: "healthcare workers to focus more on patient care. By using AI, hospitals and clinics can reduce paperwork, minimize errors, and improve operations, leading to shorter wait times and better resource management..",
                    color: 'green',
                },
                {
                    key: 3,
                    title: 'Elevate patient care by implementing AI technology',
                    subtitle: 'AI improves diagnostic accuracy by analyzing medical data, identifying patterns that humans may overlook, leading to quicker, more reliable diagnoses and better patient care.',
                    color: 'purple',
                },
            ],
            AiHealthIdeaProjectsData: [
                {
                    key: 1,
                    image: getImage('IDEAAVATAR'),
                    title: 'Customized care plans using AI insights',
                    subtitle: 'A key benefit of AI in healthcare is personalized treatment plans. AI algorithms help providers assess a patient’s medical history, genetics, lifestyle, and preferences, leading to more effective treatments and greater patient satisfaction.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
                {
                    key: 2,
                    image: getImage('PROTOTYPING'),
                    title: 'AI-Driven telemedicine and remote health solutions',
                    subtitle: 'The significance of telemedicine is growing, with AI improving remote healthcare. AI-based systems help healthcare workers monitor patients, track vital signs, and provide online consultations, allowing patients to receive quality care at home and reducing hospital visits, particularly for chronic conditions or recovery.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 3,
                    image: getImage('SOLIDDEV'),
                    title: 'Suitable for every device and platform',
                    subtitle: 'Healthcare workers must access important information anytime, anywhere. Our AI solutions are designed for all devices, providing tools for informed choices and efficient patient care, whether in the office, at home, or traveling.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                },
                {
                    key: 4,
                    image: getImage('EVALUATION'),
                    title: 'AI-Driven central data management',
                    subtitle: 'Large amounts of patient data can be hard to manage for healthcare organizations. AI simplifies this by organizing & securely storing electronic health records (EHRs), enabling quick access to essential information. This method improves care efficiency and enhances data security, ensuring compliance with laws.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                },
            ],
        },

        eCommercePage: {
            title: 'Online store development',
            description: 'Launch a unique e-commerce site with Sattva Tech to increase sales and improve the shopping experience tailored to your needs.',
            ReliabilityECommerceData: [
                {
                    key: 1,
                    image: getImage('COMPUTER'),
                    title: 'Tailored functionality',
                    subtitle: 'Create an online store that aligns with your unique business requirements.',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('SALE'),
                    title: 'Optimized for sales',
                    subtitle: 'Increase conversions with a customer-focused, intuitive interface.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('TRANSACTION'),
                    title: 'Secure transactions',
                    subtitle: 'Ensure safe online payments with secure payment gateways & data encryption.',
                    bgColor: '#842CFF',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('INCREASE'),
                    title: 'Room for growth',
                    subtitle: 'Your online store expands alongside your business, adjusting to higher traffic and sales.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 5,
                    image: getImage('CONNECTION'),
                    title: 'Easy integrations',
                    subtitle: 'Link with CRM, ERP, inventory control, and other business systems.',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
            ],
            ECommerceIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Planning',
                    subtitle: 'We kick off by exploring your business goals, identifying your target audience, & assessing your technical requirements. Together, we will define the features & integrations that will drive your e-commerce success.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & Prototyping',
                    subtitle: 'Our design team builds a nice-looking, easy-to-use interface that improves the shopping experience and boosts sales. We focus on responsive design, making sure your online store works great on any device.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('ECONLINE'),
                    title: 'Online store development & Integration',
                    subtitle: 'Our development team creates your e-commerce platform with the latest technology, ensuring it is secure and can grow. We incorporate key features like product management, payment gateways, and third-party integrations.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'purple',
                    color: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('ECTESTING'),
                    title: 'Testing & Optimization',
                    subtitle: 'We perform extensive testing on your e-commerce platform before it goes live to make sure it runs well and offers a great user experience.',
                    row: 'row-reverse',
                    justify: 'start',
                    text: 'right',
                    textColor: 'green',
                    color: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('ECDISCOVERY'),
                    title: 'Discovery & Planning',
                    subtitle: 'We kick off by exploring your business goals, identifying your target audience, & assessing your technical requirements. Together, we will define the features and integrations that will drive your e-commerce success.',
                    row: 'row',
                    justify: 'end',
                    text: 'left',
                    textColor: 'yellow',
                    color: '#FFB912'
                },
            ],
        },

        webAppPage: {
            title: 'Creating web applications',
            description: 'Discover custom web applications that enhance operations and customer interaction. SATTVA TECH creates scalable, secure web apps tailored to your needs.',
            ReliabilityWebAppData: [
                {
                    key: 1,
                    image: getImage('CUSTOM'),
                    title: 'Customized solutions',
                    subtitle: 'Web applications aim to improve your business processes for better efficiency.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('COMPATIBILITY'),
                    title: 'Cross-platform compatibility',
                    subtitle: 'Access your web application on any device desktop, tablet, or mobile.',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('STRUCTURE'),
                    title: 'Flexible structure',
                    subtitle: 'Web applications aim to improve your business processes for better efficiency.',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('INTEGRATION'),
                    title: 'Seamless integrations',
                    subtitle: 'Combine your web application with current systems.',
                    color: 'green'
                },
                {
                    key: 5,
                    image: getImage('SECURITYWEB'),
                    title: 'Enhanced security',
                    subtitle: 'Equipped with top-notch security to safeguard your information',
                    color: 'yellow'
                },
            ],
            WebAppIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Research & Strategy',
                    subtitle: 'We start by getting a clear picture of your business goals, processes, and challenges. Then, we work together to develop a plan that details the project’s scope, features, and technology.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
                {
                    key: 2,
                    image: getImage('WEBDESIGN'),
                    title: 'Tailored design for your organization',
                    subtitle: 'Our team develops user-friendly designs that boost engagement and simplify processes, ensuring easy navigation and a seamless experience.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 3,
                    image: getImage('WEBDEV'),
                    title: 'Solid development',
                    subtitle: 'Our team creates the web application with the latest technologies, making sure it is scalable, secure, and easy to connect with your current systems.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                },
                {
                    key: 4,
                    image: getImage('WEBTESTING'),
                    title: 'Evaluation & Security',
                    subtitle: 'Prior to launch, we carry out detailed testing to confirm the app is without bugs and adheres to strict security requirements.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 5,
                    image: getImage('WEBPLANNING'),
                    title: 'Implementation & Ongoing support',
                    subtitle: 'After going live, we provide ongoing support with security updates and new features. This support helps keep your enterprise app working well as your business expands.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
            ],
        },

        wordPressPage: {
            title: 'Personalized WordPress development',
            description: 'Design a beautiful, fast, and SEO-optimized WordPress website. SATTVA TECH crafts flexible sites that meet your business needs, whether it’s a basic blog or a full e-commerce platform.',
            ReliabilityWordPressData: [
                {
                    key: 1,
                    image: getImage('FLEXIBILITY'),
                    title: 'Full flexibility',
                    subtitle: 'Modify your website to suit your individual business targets',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('OPTIMIZATIONWORD'),
                    title: 'SEO optimization',
                    subtitle: 'Rank higher in search engines with optimized code and content.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('SCALE'),
                    title: 'Scale up',
                    subtitle: 'Easily add new features as your business grows.',
                    bgColor: '#842CFF',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('USERWORD'),
                    title: 'User-friendly',
                    subtitle: 'Handle your content easily, no tech skills needed',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 5,
                    image: getImage('WORDSECURITY'),
                    title: 'Security',
                    subtitle: 'Enhanced security measures to protect your website and data',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
            ],
            WordPressIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Research & Strategy',
                    subtitle: 'We kick off by gaining a deep understanding of your business aims, target audience, and technical requirements. Together, we identify the features and design that match your vision.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design',
                    subtitle: 'Our design team builds an easy-to-use and attractive interface that improves user experience and matches your brand style.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 3,
                    image: getImage('WORDDEV'),
                    title: 'Development',
                    subtitle: 'We have WordPress developers who use cutting-edge technologies to design your website, ensuring it is fast, safe, and search engine friendly.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                },
                {
                    key: 4,
                    image: getImage('WORDTESTING'),
                    title: 'Testing',
                    subtitle: 'Before launching, we check the website thoroughly to confirm it operates perfectly. We also make the site load faster to boost the user experience.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                },
                {
                    key: 5,
                    image: getImage('WORDLAUNCH'),
                    title: 'Launch & Support',
                    subtitle: 'Once your site is live, we give regular support and maintenance to make sure it remains updated and secure.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                },
            ],
        },

        websiteSupportPage: {
            title: 'Website care & Assistance',
            description: 'A website is never complete; it needs ongoing maintenance for optimal performance. SATTVA TECH delivers comprehensive web maintenance services, so you can concentrate on your business.',
            ReliabilityWebSupportData: [
                {
                    key: 1,
                    image: getImage('WEBSECURITY'),
                    title: 'Security updates',
                    subtitle: 'Regularly updating your software & applying patches can help shield your site from security threats.',
                    bgColor: '#FFB912',
                },
                {
                    key: 2,
                    image: getImage('ENHANCING'),
                    title: 'Enhancing performance',
                    subtitle: 'Improve speed and efficiency to enhance user experience and boost SEO.',
                    bgColor: '#98FF12',
                },
                {
                    key: 3,
                    image: getImage('UPDATES'),
                    title: 'Content updates',
                    subtitle: 'Update your website content regularly to attract visitors and improve your search rankings.',
                    bgColor: '#842CFF',
                },
                {
                    key: 4,
                    image: getImage('RECOVERY'),
                    title: 'Backups and recovery',
                    subtitle: 'Regular backups to ensure you can quickly recover your site in case of any issues.',
                    bgColor: '#98FF12',
                },
                {
                    key: 5,
                    image: getImage('SUPPORT'),
                    title: 'Technical support',
                    subtitle: 'Ongoing support to resolve issues, fix bugs, and implement updates.',
                    bgColor: '#FFB912',
                },
            ],
            WebsiteSupportIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Security & Software updates',
                    subtitle: 'Our process starts with a thorough review of your business operations, challenges, and objectives. We work together to outline the features and functions that will ensure the app’s success in line with your business goals.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Update your core software:',
                            subTitle: 'Regularly update your CMS, plugins, and themes to guard against security risks.'
                        },
                        {
                            key: 2,
                            title: 'Apply security patches:',
                            subTitle: 'Install important security updates immediately to avoid data leaks.'
                        },
                        {
                            key: 3,
                            title: 'Monitor SSL:',
                            subTitle: 'Make sure your SSL certificate is current to safeguard user information and build trust.'
                        },
                        {
                            key: 4,
                            title: 'Keep software current:',
                            subTitle: 'Regularly refresh your CMS, plugins, and themes to protect from weaknesses.'
                        },
                    ]
                },
                {
                    key: 2,
                    image: getImage('WSOPTIMIZATION'),
                    title: 'Tailored design for your organization',
                    subtitle: 'The design team creates a straightforward interface that benefits both employees and customers. We prioritize usability and excellent performance.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    list: [
                        {
                            key: 1,
                            title: 'Update your core software:',
                            subTitle: 'Regularly update your CMS, plugins, and themes to guard against security risks.'
                        },
                        {
                            key: 2,
                            title: 'Apply security patches:',
                            subTitle: 'Install important security updates immediately to avoid data leaks.'
                        },
                        {
                            key: 3,
                            title: 'Monitor SSL:',
                            subTitle: 'Make sure your SSL certificate is current to safeguard user information and build trust.'
                        },
                        {
                            key: 4,
                            title: 'Keep software current:',
                            subTitle: 'Regularly refresh your CMS, plugins, and themes to protect from weaknesses.'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('WSUPDATES'),
                    title: 'Solid development',
                    subtitle: 'We build your app with the highest standards, ensuring it is stable, secure, and capable of managing large data and user volumes. You will receive regular updates to keep you informed about our progress.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    list: [
                        {
                            key: 1,
                            title: 'Update your core software:',
                            subTitle: 'Regularly update your CMS, plugins, and themes to guard against security risks.'
                        },
                        {
                            key: 2,
                            title: 'Apply security patches:',
                            subTitle: 'Install important security updates immediately to avoid data leaks.'
                        },
                        {
                            key: 3,
                            title: 'Monitor SSL:',
                            subTitle: 'Make sure your SSL certificate is current to safeguard user information and build trust.'
                        },
                        {
                            key: 4,
                            title: 'Keep software current:',
                            subTitle: 'Regularly refresh your CMS, plugins, and themes to protect from weaknesses.'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('WSRECOVERY'),
                    title: 'Evaluation & Security',
                    subtitle: 'Prior to launch, we carry out detailed testing to confirm the app is without bugs and adheres to strict security requirements.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    list: [
                        {
                            key: 1,
                            title: 'Update your core software:',
                            subTitle: 'Regularly update your CMS, plugins, and themes to guard against security risks.'
                        },
                        {
                            key: 2,
                            title: 'Apply security patches:',
                            subTitle: 'Install important security updates immediately to avoid data leaks.'
                        },
                        {
                            key: 3,
                            title: 'Monitor SSL:',
                            subTitle: 'Make sure your SSL certificate is current to safeguard user information and build trust.'
                        },
                        {
                            key: 4,
                            title: 'Keep software current:',
                            subTitle: 'Regularly refresh your CMS, plugins, and themes to protect from weaknesses.'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('WSSUPPORT'),
                    title: 'Implementation & Ongoing support',
                    subtitle: 'After going live, we provide ongoing support with security updates and new features. This support helps keep your enterprise app working well as your business expands.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Update your core software:',
                            subTitle: 'Regularly update your CMS, plugins, and themes to guard against security risks.'
                        },
                        {
                            key: 2,
                            title: 'Apply security patches:',
                            subTitle: 'Install important security updates immediately to avoid data leaks.'
                        },
                        {
                            key: 3,
                            title: 'Monitor SSL:',
                            subTitle: 'Make sure your SSL certificate is current to safeguard user information and build trust.'
                        },
                        {
                            key: 4,
                            title: 'Keep software current:',
                            subTitle: 'Regularly refresh your CMS, plugins, and themes to protect from weaknesses.'
                        },
                    ]
                },
            ],
            WebSupportFeatureList: [
                {
                    key: 1,
                    image: getImage('WEBPLANS'),
                    title: 'Customized plans',
                    subtitle: "Pick a maintenance plan that matches your business's size and needs.",
                    bgColor: '[#FFB912]',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('WEBSUPPORT'),
                    title: 'Expert support',
                    subtitle: 'Our talented developers are always on standby to offer fast and consistent assistance.',
                    bgColor: '[#98FF12]',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('WEBPROACTIVE'),
                    title: 'Proactive approach',
                    subtitle: 'We don’t just fix problems; we prevent them.',
                    bgColor: '[#842CFF]',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('WEBSCHEDULE'),
                    title: 'Flexible scheduling',
                    subtitle: 'We can take care of your site every month, every three months, or once a year—whichever option is best for you.',
                    bgColor: '[#FFB912]',
                    color: 'yellow'
                },
            ],
        },

        hospitalDashPage: {
            title: 'Hospital dashboard',
            description: 'Elevate your hospital’s efficiency and decision-making with custom dashboards that deliver real-time insights into crucial data. SATTVA TECH creates user-friendly and secure dashboards designed for your specific needs, focusing on patient monitoring, resource  management, & performance metrics.',
            ReliabilityHosDashData: [
                {
                    key: 1,
                    title: 'Real-time data',
                    subtitle: 'View real-time patient data, resource consumption, and financial statistic.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    title: 'Centralized management',
                    subtitle: 'See all important information in one spot to make decisions easier and enhance teamwork.',
                    color: 'green'
                },
                {
                    key: 3,
                    title: 'Adjustable displays',
                    subtitle: 'Adjust dashboards to fit the needs of departments like administration, patient care, finance, and others.',
                    color: 'purple'
                },
                {
                    key: 4,
                    title: 'Compliance and security',
                    subtitle: 'Keep data secure and follow healthcare regulations, including HIPAA.',
                    color: 'green'
                },
                {
                    key: 5,
                    title: 'Design focused on users',
                    subtitle: 'Our focus is on achieving seamless interaction for both our internal groups and the external parties we engage with.',
                    color: 'yellow'
                },
            ],
            HosDashIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Requirements gathering',
                    subtitle: 'We kick off by identifying your hospital’s needs, existing data sources, and operational difficulties. This helps us set the scope and features for your custom dashboards.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Operational analysis'
                        },
                        {
                            key: 2,
                            title: 'System audit'
                        },
                        {
                            key: 3,
                            title: 'Requirement gathering'
                        },
                        {
                            key: 4,
                            title: 'Roadmap development'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Dashboard design & Prototyping',
                    subtitle: 'We create dashboards that are simple and user-friendly, highlighting important information right away. Our team ensures these dashboards can be customized and are easy to navigate for various hospital departments.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'WireFrames and mockups'
                        },
                        {
                            key: 2,
                            title: 'Data visualization'
                        },
                        {
                            key: 3,
                            title: 'Interactive prototypes'
                        },
                        {
                            key: 4,
                            title: 'Responsive design'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HOSDASHINTEGRATE'),
                    title: 'Integration and Development',
                    subtitle: 'Our design team makes intuitive dashboards that present essential information clearly. We prioritize customization, easy navigation, and the specific needs of different hospital departments.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    steps: [
                        {
                            key: 1,
                            title: 'Data integration'
                        },
                        {
                            key: 2,
                            title: 'Custom modules'
                        },
                        {
                            key: 3,
                            title: 'Role-based access'
                        },
                        {
                            key: 4,
                            title: 'Security and compliance'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HOSDASHTESTING'),
                    title: 'Testing & Optimization',
                    subtitle: 'Before we go live, we do careful testing to ensure the dashboard runs smoothly and provides correct, real-time data. We also work on performance to guarantee quick loading and easy operation.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'Data accuracy testing'
                        },
                        {
                            key: 2,
                            title: 'Performance testing'
                        },
                        {
                            key: 3,
                            title: 'User acceptance testing'
                        },
                        {
                            key: 4,
                            title: 'Security testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HOSDASHSUPPORT'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'After testing is done, we take care of launching your custom dashboard. Once it’s live, we offer ongoing support to keep your dashboard safe, current, and running well.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Seamless deployment'
                        },
                        {
                            key: 2,
                            title: 'Ongoing maintenance'
                        },
                        {
                            key: 3,
                            title: 'Training and support'
                        },
                        {
                            key: 4,
                            title: 'Monitoring and support'
                        },
                    ]
                },
            ],
            HosDashFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'purple',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
            ],
        },

        hospitalIntranetPage: {
            title: 'Hospital intranet',
            description: 'Simplify internal communication and resource management with a custom hospital intranet from SATTVA TECH. Our secure solutions include centralized document management and real-time collaboration tools.',
            ReliabilityHoshIntraData: [
                {
                    key: 1,
                    title: 'Improved communication',
                    subtitle: 'Enable quick messaging, employee lists, and announcements for the entire hospital.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 2,
                    title: 'Centralized document access',
                    subtitle: 'Organize and share policies, procedures, and medical guidelines all in one location.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 3,
                    title: 'Better cooperation',
                    subtitle: 'Support teamwork across departments by providing shared workspaces and discussion platforms.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
                {
                    key: 4,
                    title: 'Resource management',
                    subtitle: 'Track staff schedules, meeting rooms, and equipment availability.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 5,
                    title: 'Security and compliance',
                    subtitle: 'Make sure all internal messages and documents are safe and follow healthcare rules.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
            ],
            HosIntraIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Requirements gathering',
                    subtitle: 'We kick off by identifying your hospital’s needs, existing data sources, and operational difficulties. This helps us set the scope and features for your custom dashboards.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    bgColor: '#FFB912',
                    steps: [
                        {
                            key: 1,
                            title: 'Operational analysis'
                        },
                        {
                            key: 2,
                            title: 'System audit'
                        },
                        {
                            key: 3,
                            title: 'Requirement gathering'
                        },
                        {
                            key: 4,
                            title: 'Roadmap development'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Dashboard design & Prototyping',
                    subtitle: 'We create dashboards that are simple and user-friendly, highlighting important information right away. Our team ensures these dashboards can be customized and are easy to navigate for various hospital departments.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    bgColor: '#98FF12',
                    steps: [
                        {
                            key: 1,
                            title: 'WireFrames and mockups'
                        },
                        {
                            key: 2,
                            title: 'Data visualization'
                        },
                        {
                            key: 3,
                            title: 'Interactive prototypes'
                        },
                        {
                            key: 4,
                            title: 'Responsive design'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HOSDASHINTEGRATE'),
                    title: 'Integration and Development',
                    subtitle: 'Our design team makes intuitive dashboards that present essential information clearly. We prioritize customization, easy navigation, and the specific needs of different hospital departments.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    bgColor: '#842CFF',
                    steps: [
                        {
                            key: 1,
                            title: 'Data integration'
                        },
                        {
                            key: 2,
                            title: 'Custom modules'
                        },
                        {
                            key: 3,
                            title: 'Role-based access'
                        },
                        {
                            key: 4,
                            title: 'Security and compliance'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HOSDASHTESTING'),
                    title: 'Testing & Optimization',
                    subtitle: 'Before we go live, we do careful testing to ensure the dashboard runs smoothly and provides correct, real-time data. We also work on performance to guarantee quick loading and easy operation.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    bgColor: '#98FF12',
                    steps: [
                        {
                            key: 1,
                            title: 'Data accuracy testing'
                        },
                        {
                            key: 2,
                            title: 'Performance testing'
                        },
                        {
                            key: 3,
                            title: 'User acceptance testing'
                        },
                        {
                            key: 4,
                            title: 'Security testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HOSDASHSUPPORT'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'After testing is done, we take care of launching your custom dashboard. Once it’s live, we offer ongoing support to keep your dashboard safe, current, and running well.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    bgColor: '#FFB912',
                    steps: [
                        {
                            key: 1,
                            title: 'Seamless deployment'
                        },
                        {
                            key: 2,
                            title: 'Ongoing maintenance'
                        },
                        {
                            key: 3,
                            title: 'Training and support'
                        },
                        {
                            key: 4,
                            title: 'Monitoring and support'
                        },
                    ]
                },
            ],
            HosIntraFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'purple',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
            ],

        },

        epdSystemPage: {
            title: 'EPD/EHR system',
            description: 'Improve patient data management with a personalized EPD or EHR system from SATTVA TECH.  We focus on secure, scalable, and compliant systems that streamline medical records management, enhance patient care, and ensure HIPAA and GDPR compliance',
            ReliabilityERPSystemData: [
                {
                    key: 1,
                    image: getImage('EPDDATASHARING'),
                    title: 'Centralized data management',
                    subtitle: 'Organize patient records in a centralized area that allows for easy access and updates.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
                {
                    key: 2,
                    image: getImage('EPDPATIENT'),
                    title: 'Improved patient care',
                    subtitle: 'Improve patient care by accessing medical histories, lab results, and treatment plans in real-time.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 3,
                    image: getImage('EPDREGULATIONS'),
                    title: 'Compliance with regulations',
                    subtitle: 'Make sure to follow all healthcare data rules like HIPAA and GDPR.',
                    color: 'purple',
                    bgColor: '#842CFF'
                },
                {
                    key: 4,
                    image: getImage('EPDINTEGRATION'),
                    title: 'Simple integration',
                    subtitle: 'Connect your EPD/EHR system with other hospital systems such as billing, laboratories, and pharmacies.',
                    color: 'green',
                    bgColor: '#98FF12'
                },
                {
                    key: 5,
                    image: getImage('EPDCAPACITY'),
                    title: 'Capacity to expand',
                    subtitle: 'As your facility gets bigger, your EPD/EHR system can readily adapt and scale to fulfill new needs.',
                    color: 'yellow',
                    bgColor: '#FFB912'
                },
            ],
            EPDSystemIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Planning',
                    subtitle: 'We begin by looking at the needs and goals of your health care facility. Our team collaborates with you to grasp the workflows, patient care issues, and regulations that are unique to your organization.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Needs assessment'
                        },
                        {
                            key: 2,
                            title: 'Regulatory analysis'
                        },
                        {
                            key: 3,
                            title: 'Technical planning'
                        },
                        {
                            key: 4,
                            title: 'Project roadmap'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & Prototyping',
                    subtitle: 'We have a design team that makes a simple and safe interface for healthcare providers and patients. Our goal is to create intuitive apps that give users a great experience while also being very secure.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'Wireframes and mockups'
                        },
                        {
                            key: 2,
                            title: 'Prototyping'
                        },
                        {
                            key: 3,
                            title: 'Responsive design'
                        },
                        {
                            key: 4,
                            title: 'User experience (UX) focus'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HEALTHDEV'),
                    title: 'Development & Implementation',
                    subtitle: 'We develop your healthcare app using secure and scalable tech.Key features like patient portals, telemedicine services, and EHR systems are included for easy operation.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    steps: [
                        {
                            key: 1,
                            title: 'Secure coding'
                        },
                        {
                            key: 2,
                            title: 'API integrations'
                        },
                        {
                            key: 3,
                            title: 'Telemedicine platforms'
                        },
                        {
                            key: 4,
                            title: 'Data encryption'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HEALTHTESTING'),
                    title: 'Testing & Compliance',
                    subtitle: 'Prior to launching, we conduct extensive tests on the app to guarantee it meets high standards for security, usability, and regulatory compliance. This includes checking its functionality, performance, and security.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'HIPAA compliance testing'
                        },
                        {
                            key: 2,
                            title: 'Functionality testing'
                        },
                        {
                            key: 3,
                            title: 'Performance testing'
                        },
                        {
                            key: 4,
                            title: 'User acceptance testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HEALTHONGOING'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'When testing finishes, we take care of deploying your healthcare app and provide ongoing assistance to keep it safe, current, and fully optimized.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Support and training'
                        },
                        {
                            key: 2,
                            title: 'Future scalability'
                        },
                        {
                            key: 3,
                            title: 'Compliance monitoring'
                        },
                    ]
                },
            ],
            EPDSystemFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'green',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'purple',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                            subtitle: 'Allow patients to schedule appointments, view health records, and communicate with providers.',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                            subtitle: 'Automate and streamline the appointment booking process for both patients and staff.',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                            subtitle: 'Send automated notifications for appointments, prescription refills, and follow-ups.',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                            subtitle: 'Enable patients to track vital signs and health metrics via integrated wearables or manual input.',
                        },
                    ]
                },
            ],
        },

        erpSoftwarePage: {
            title: 'Development of ERP software',
            description: 'Enhance your business processes with an exclusive ERP solution from SATTVA TECH. Our systems centralize data and streamline workflows to optimize inventory, finance, HR, and sales operations.',
            ReliabilityERPSoftwareData: [
                {
                    key: 1,
                    image: getImage('ERPBUSINESS'),
                    title: 'Tailored to your business',
                    subtitle: 'ERP software created just for your workflows and goals.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('ERPDECISION'),
                    title: 'Improved decision-making',
                    subtitle: 'Get live data and insights from all areas of your business.',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('ERPINTEGRATION'),
                    title: 'Enhanced productivity',
                    subtitle: 'Reduce repetitive work & improve how the team works together.',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('ERPPRODUCTIVITY'),
                    title: 'Seamless integration',
                    subtitle: 'Integrate with existing platforms such as CRM, HR.',
                    color: 'green'
                },
            ],
            ERPSoftwareIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Planning',
                    subtitle: 'We begin by looking at the needs and goals of your health care facility. Our team collaborates with you to grasp the workflows, patient care issues, and regulations that are unique to your organization.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Needs assessment'
                        },
                        {
                            key: 2,
                            title: 'Regulatory analysis'
                        },
                        {
                            key: 3,
                            title: 'Technical planning'
                        },
                        {
                            key: 4,
                            title: 'Project roadmap'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & Prototyping',
                    subtitle: 'We have a design team that makes a simple and safe interface for healthcare providers and patients. Our goal is to create intuitive apps that give users a great experience while also being very secure.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'Wireframes and mockups'
                        },
                        {
                            key: 2,
                            title: 'Prototyping'
                        },
                        {
                            key: 3,
                            title: 'Responsive design'
                        },
                        {
                            key: 4,
                            title: 'User experience (UX) focus'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HEALTHDEV'),
                    title: 'Development & Implementation',
                    subtitle: 'We develop your healthcare app using secure and scalable tech.Key features like patient portals, telemedicine services, and EHR systems are included for easy operation.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    steps: [
                        {
                            key: 1,
                            title: 'Secure coding'
                        },
                        {
                            key: 2,
                            title: 'API integrations'
                        },
                        {
                            key: 3,
                            title: 'Telemedicine platforms'
                        },
                        {
                            key: 4,
                            title: 'Data encryption'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HEALTHTESTING'),
                    title: 'Testing & Compliance',
                    subtitle: 'Prior to launching, we conduct extensive tests on the app to guarantee it meets high standards for security, usability, and regulatory compliance. This includes checking its functionality, performance, and security.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'HIPAA compliance testing'
                        },
                        {
                            key: 2,
                            title: 'Functionality testing'
                        },
                        {
                            key: 3,
                            title: 'Performance testing'
                        },
                        {
                            key: 4,
                            title: 'User acceptance testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HEALTHONGOING'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'When testing finishes, we take care of deploying your healthcare app and provide ongoing assistance to keep it safe, current, and fully optimized.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Support and training'
                        },
                        {
                            key: 2,
                            title: 'Future scalability'
                        },
                        {
                            key: 3,
                            title: 'Compliance monitoring'
                        },
                    ]
                },
            ],
            ERPSoftwareFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
            ],
        },

        saasSoftwarePage: {
            title: 'SaaS software',
            description: 'Enhance your business with scalable, cloud-based SaaS solutions. SATTVA TECH designs custom SaaS applications that improve service delivery and support expansion, focusing on flexibility, security, and ease of use for subscription and enterprise needs.',
            ReliabilitySaaSSoftwareData: [
                {
                    key: 1,
                    title: 'Tailored to your business',
                    subtitle: 'ERP software created just for your workflows and goals.',
                    color: 'yellow'
                },
                {
                    key: 2,
                    title: 'Improved decision-making',
                    subtitle: 'Get live data and insights from all areas of your business.',
                    color: 'green'
                },
                {
                    key: 3,
                    title: 'Enhanced productivity',
                    subtitle: 'Reduce repetitive work & improve how the team works together.',
                    color: 'purple'
                },
                {
                    key: 4,
                    title: 'Seamless integration',
                    subtitle: 'Integrate with existing platforms such as CRM, HR.',
                    color: 'green'
                },
            ],
            SaaSSoftwareIdeaProjectsData: [
                {
                    key: 1,
                    image: '',
                    title: 'Discovery & Planning',
                    subtitle: 'We begin by looking at the needs and goals of your health care facility. Our team collaborates with you to grasp the workflows, patient care issues, and regulations that are unique to your organization.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Needs assessment'
                        },
                        {
                            key: 2,
                            title: 'Regulatory analysis'
                        },
                        {
                            key: 3,
                            title: 'Technical planning'
                        },
                        {
                            key: 4,
                            title: 'Project roadmap'
                        },
                    ]
                },
                {
                    key: 2,
                    image: '',
                    title: 'Design & Prototyping',
                    subtitle: 'We have a design team that makes a simple and safe interface for healthcare providers and patients. Our goal is to create intuitive apps that give users a great experience while also being very secure.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'Wireframes and mockups'
                        },
                        {
                            key: 2,
                            title: 'Prototyping'
                        },
                        {
                            key: 3,
                            title: 'Responsive design'
                        },
                        {
                            key: 4,
                            title: 'User experience (UX) focus'
                        },
                    ]
                },
                {
                    key: 3,
                    image: getImage('HEALTHDEV'),
                    title: 'Development & Implementation',
                    subtitle: 'We develop your healthcare app using secure and scalable tech.Key features like patient portals, telemedicine services, and EHR systems are included for easy operation.',
                    row: 'row',
                    text: 'left',
                    textColor: 'purple',
                    steps: [
                        {
                            key: 1,
                            title: 'Secure coding'
                        },
                        {
                            key: 2,
                            title: 'API integrations'
                        },
                        {
                            key: 3,
                            title: 'Telemedicine platforms'
                        },
                        {
                            key: 4,
                            title: 'Data encryption'
                        },
                    ]
                },
                {
                    key: 4,
                    image: getImage('HEALTHTESTING'),
                    title: 'Testing & Compliance',
                    subtitle: 'Prior to launching, we conduct extensive tests on the app to guarantee it meets high standards for security, usability, and regulatory compliance. This includes checking its functionality, performance, and security.',
                    row: 'row-reverse',
                    text: 'right',
                    textColor: 'green',
                    steps: [
                        {
                            key: 1,
                            title: 'HIPAA compliance testing'
                        },
                        {
                            key: 2,
                            title: 'Functionality testing'
                        },
                        {
                            key: 3,
                            title: 'Performance testing'
                        },
                        {
                            key: 4,
                            title: 'User acceptance testing'
                        },
                    ]
                },
                {
                    key: 5,
                    image: getImage('HEALTHONGOING'),
                    title: 'Deployment & Ongoing support',
                    subtitle: 'When testing finishes, we take care of deploying your healthcare app and provide ongoing assistance to keep it safe, current, and fully optimized.',
                    row: 'row',
                    text: 'left',
                    textColor: 'yellow',
                    steps: [
                        {
                            key: 1,
                            title: 'Support and training'
                        },
                        {
                            key: 2,
                            title: 'Future scalability'
                        },
                        {
                            key: 3,
                            title: 'Compliance monitoring'
                        },
                    ]
                },
            ],
            SaaSSoftwareFeatureList: [
                {
                    key: 1,
                    title: 'Patient management',
                    bgColor: '#FFB912',
                    bgNoColor: '[#FFB912]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
                {
                    key: 2,
                    title: 'Telemedicine & Remote care',
                    bgColor: '#98FF12',
                    bgNoColor: '[#98FF12]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
                {
                    key: 3,
                    title: 'Data security & Compliance',
                    bgColor: '#842CFF',
                    bgNoColor: '[#842CFF]',
                    color: 'yellow',
                    list: [
                        {
                            key: 1,
                            title: 'Patient portals',
                        },
                        {
                            key: 2,
                            title: 'Appointment scheduling',
                        },
                        {
                            key: 3,
                            title: 'Patient reminders',
                        },
                        {
                            key: 4,
                            title: 'Health tracking',
                        },
                    ]
                },
            ],
        },

        eccProjectPage: {
            eccProjectDetails: {
                websiteDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'Excellent care clinics'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'Website development'
                    },
                ]
            },
        },

        moodyProjectPage: {
            moodyProjectDetails: {
                websiteDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'Moody Month'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'Website development'
                    },
                ],
                AppDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'Moody Month'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'App development'
                    },
                ],
                AppSteps: [
                    {
                        key: 1,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    },
                    {
                        key: 2,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    },
                    {
                        key: 3,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    },
                    {
                        key: 4,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    },
                    {
                        key: 5,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    },
                    {
                        key: 6,
                        title: 'Automate the cleaning and sterilization process to ensure compliance with hygiene standards.'
                    }
                ]
            },
        },

        aiChatProjectPage: {
            aichatProjectDetails: {
                websiteDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'AI Chat'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'App development'
                    },
                ]
            },
        },

        bitEuProjectPage: {
            bitEuProjectDetails: {
                websiteDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'Bit.EU'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'App development'
                    },
                ],
                AppDetails: [
                    {
                        key: 1,
                        image: 'CLIENT',
                        title: 'Client:',
                        sub_title: 'Bit.EU'
                    },
                    {
                        key: 2,
                        image: 'CALENDAR',
                        title: 'Release Date:',
                        sub_title: '2023'
                    },
                    {
                        key: 3,
                        image: 'INDUSTRY',
                        title: 'Industry:',
                        sub_title: 'Health & Fitness'
                    },
                    {
                        key: 4,
                        image: 'DELIVERY',
                        title: 'Deliverables:',
                        sub_title: 'Web development'
                    },
                ],
            },
        },



        projects: {
            ProjectsList: [
                {
                    key: 1,
                    title: 'AI Chat',
                    description: 'Get the technology platform that gives you freedom to manage and grow your business, by eliminating the barriers of scale and capital.',
                    projectImage: getImage('AIBANNERIMAGE'),
                    projectNavigate: '/aichat'
                },
                {
                    key: 2,
                    title: 'BIT.EU Website',
                    description: 'Arzooo Express was developed to ease the process of Warehouse managers and workers for procurement and ease of shipping an order from warehouse. Scanning feature in the mobile app enabled the users to scan the products on a faster pace to add and process the items for orders.It helped warehouse managers to keep an active tab on vehicles loaded from their location and items needed to load.',
                    projectImage: getImage('BITEUWEBBANNER'),
                    projectNavigate: '/biteuweb'
                },
                {
                    key: 3,
                    title: 'ECC Website',
                    description: 'Personalized Chronic Care Management for a Happy and Healthy Life. MyTatva is a multi-disciplinary chronic care management app, designed to address all aspects of a patient’s health journey.',
                    projectImage: getImage('ECCBANNERIMAGE'),
                    projectNavigate: '/ecc'
                },
                {
                    key: 4,
                    title: 'MoodyMonth',
                    description: 'Personalized Chronic Care Management for a Happy and Healthy Life. MyTatva is a multi-disciplinary chronic care management app, designed to address all aspects of a patient’s health journey.',
                    projectImage: getImage('MOODYAPPBANNERIMAGE'),
                    projectNavigate: '/moodymonthapp'
                },
                {
                    key: 5,
                    title: 'BIT.EU',
                    description: 'Arzooo Express was developed to ease the process of Warehouse managers and workers for procurement and ease of shipping an order from warehouse. Scanning feature in the mobile app enabled the users to scan the products on a faster pace to add and process the items for orders.It helped warehouse managers to keep an active tab on vehicles loaded from their location and items needed to load.',
                    projectImage: getImage('BITEUBANNERIMAGE'),
                    projectNavigate: '/biteu'
                },
                {
                    key: 6,
                    title: 'ECC',
                    description: 'Arzooo Express was developed to ease the process of Warehouse managers and workers for procurement and ease of shipping an order from warehouse. Scanning feature in the mobile app enabled the users to scan the products on a faster pace to add and process the items for orders.It helped warehouse managers to keep an active tab on vehicles loaded from their location and items needed to load.',
                    projectImage: getImage('ECCAPPBANNER'),
                    projectNavigate: '/eccapp'
                },
                {
                    key: 7,
                    title: 'Moody Month Website',
                    description: 'visuEats is a restaurant web and mobile app that provide a photo and video menu displayed powered by eternity solution inclusive of reservation payment processing and delivery features.',
                    projectImage: getImage('MOODYBANNERIMAGE'),
                    projectNavigate: '/moodymonth'
                },

            ]
        },

        HomePageData: {
            company_email: "hrsattvatech@gmail.com",
            company_address: "438,The Boulevard, Near Pratham Circle, Gallaria Street Green city road , pal , Adajan, Surat, Gujarat 395009",
            company_address_2: "5a, 1A Cross Rd, Dollar Scheme Colony, 1st Stage, BTM 1st Stage, Bengaluru, Karnataka 56006",
            company_number: "+917016941771",
            steps: [
                {
                    title: `Setup and Onboarding`, icon: getImage('BULB'),
                    bgColor: 'bg-yellow', borderColor: 'outline-[#ffffff12]', arrowType: 'down', isYellow: true
                },
                { title: 'Strategy and Planning', icon: getImage('STRATEGY'), bgColor: 'bg-green', borderColor: 'outline-[#00AC8D]', arrowType: 'up', isYellow: false },
                { title: 'Lead Generation', icon: getImage('LEAD'), bgColor: 'bg-purple', borderColor: 'outline-[#5A49F8]', arrowType: 'down', isYellow: false },
                { title: 'Sales and CRM Integration', icon: getImage('SALES'), bgColor: 'bg-yellow', borderColor: 'outline-[#36BAFE]', arrowType: 'up', isYellow: true },
                { title: 'Testing and Optimization', icon: getImage('TESTING'), bgColor: 'bg-green', borderColor: 'outline-[#FF3838]', arrowType: 'down', isYellow: false },
                { title: 'Training and Education', icon: getImage('TRAINING'), bgColor: 'bg-purple', borderColor: 'outline-[#F8AE1F]', arrowType: 'up', isYellow: false },
                { title: 'Review and Reporting', icon: getImage('REVIEW'), bgColor: 'bg-yellow', borderColor: 'outline-[#3DAF2B]', isYellow: true },
            ],
            serviceQuestionList: [
                {
                    key: 1,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Expertise and experience",
                    desciprtion: "A  team of experienced professionals, well-versed in the latest technologies and best practices."
                },
                {
                    key: 2,
                    arrowColor: "#98FF12",
                    textColor: "green",
                    title: "Customized solutions",
                    desciprtion: "Highly customized solutions tailored to meet the needs of the clients and their customers"
                },
                {
                    key: 3,
                    arrowColor: "#842CFF",
                    textColor: "purple",
                    title: "Proven track record",
                    desciprtion: "A proven track record of delivering successful IT solutions to businesses across a range of industries."
                },
                {
                    key: 4,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Time and cost savings",
                    desciprtion: "We strive to deliver efficient and cost-effective solutions that help our clients maximize their resources"
                },
                {
                    key: 5,
                    arrowColor: "#98FF12",
                    textColor: "green",
                    title: "Quality assurance",
                    desciprtion: "Our quality assurance team uses a combination of manual testing and automated tools to thoroughly test software applications."
                },
                {
                    key: 6,
                    arrowColor: "#842CFF",
                    textColor: "purple",
                    title: "Communication and collaboration",
                    desciprtion: "We believe that effective communication and collaboration are key to the success of any project"
                },
                {
                    key: 7,
                    arrowColor: "#FFB912",
                    textColor: "yellow",
                    title: "Flexibility and scalability",
                    desciprtion: "Needs of businesses can change rapidly, we are prepared to adapt to these changes in order to support our client's success."
                },

            ],
            headerServicesList: [
                {
                    key: 1,
                    title: 'App Development',
                    value: [
                        {
                            key: 1,
                            value: 'IOS App development',
                            navigate: '/ios'
                        },
                        {
                            key: 2,
                            value: 'Android App development',
                            navigate: '/android'
                        },
                        // {
                        //     key: 3,
                        //     value: 'Enterprise App development',
                        //     navigate: '/enterprise'
                        // },
                        // {
                        //     key: 4,
                        //     value: 'App Maintenance & Updates',
                        //     navigate: '/appsupport'
                        // },
                    ]
                },
                {
                    key: 2,
                    title: 'Software Development',
                    value: [
                        {
                            key: 1,
                            value: 'Custom Service development',
                            navigate: '/service'
                        },
                    ]
                },
                // {
                //     key: 3,
                //     title: 'Healthcare / Medical Software',
                //     value: [
                //         {
                //             key: 1,
                //             value: 'Healthcare App development',
                //             navigate: '/healthcare'
                //         },
                //         {
                //             key: 2,
                //             value: 'Hospital website development',
                //             navigate: '/hospitaldash'
                //         },
                //         {
                //             key: 3,
                //             value: 'Hospital Intranet development',
                //             navigate: '/hospitalintranet'
                //         },
                //         {
                //             key: 4,
                //             value: 'EPD/EHR System development',
                //             navigate: '/epdsystem'
                //         },
                //         {
                //             key: 5,
                //             value: 'Erp Software development',
                //             navigate: '/erpsoftware'
                //         },
                //     ]
                // },
                // {
                //     key: 3,
                //     title: 'AI Solutions',
                //     value: [
                //         {
                //             key: 1,
                //             value: 'Businesses AI development',
                //             navigate: '/aibusiness'
                //         },
                //         {
                //             key: 2,
                //             value: 'Healthcare AI development',
                //             navigate: '/aihealthcare'
                //         },
                //     ]
                // },
                // {
                //     key: 5,
                //     title: 'Web Development',
                //     value: [
                //         {
                //             key: 1,
                //             value: 'ECommerce development',
                //             navigate: '/ecommerce'
                //         },
                //         {
                //             key: 2,
                //             value: 'Web development',
                //             navigate: '/webapp'
                //         },
                //         {
                //             key: 3,
                //             value: 'Wordpress development',
                //             navigate: '/wordpress'
                //         },
                //         {
                //             key: 4,
                //             value: 'Website Maintenance & Support',
                //             navigate: '/websitesupport'
                //         },
                //     ]
                // },
            ],
            testimonialsData: [
                {
                    key: '1',
                    review: 'I had the distinct privilege of working with Sattva Tech as a TypeScript developer. Their remarkable contributions and technical expertise significantly enhanced our projects.',
                    client: 'Brendon E',
                    star: 5,
                    designation: 'CEO, Sattva Tech',
                },
                {
                    key: '2',
                    review: 'Sattva Tech consistently demonstrated exceptional proficiency in TypeScript and JavaScript, adeptly developing applications that met our clients diverse needs. Their ability to build and sustain PowerApps PC components showcased their technical versatility.',
                    client: 'Adam K',
                    star: 5,
                    designation: 'CEO, AI Chat',
                },
                {
                    key: '3',
                    review: 'A standout trait of Sattva Tech is their attention to detail and exemplary UI design skills, ensuring a seamless user experience. Their strong grasp of CI/CD processes and effective use of VS Code facilitated efficient development workflows.',
                    client: 'Vahram M',
                    star: 5,
                    designation: 'Founder',
                },
                {
                    key: '4',
                    review: "Sattva Tech's familiarity with various JavaScript frameworks allowed them to adapt quickly to project requirements. Their proactive attitude and ability to recommend improvements demonstrated their commitment to enhancing our projects.",
                    client: 'Gilad S',
                    star: 5,
                    designation: 'Founder, BIT.EU',
                },
                {
                    key: '5',
                    review: 'Communication was key in our collaboration, and Sattva Tech excelled in this area. Their fluency in English and strong interpersonal skills fostered effective problem-solving and teamwork. I highly recommend Sattva Tech for any TypeScript development opportunities!',
                    client: 'Harshwardhan K',
                    star: 5,
                    designation: 'Founder',
                },
                {
                    key: '6',
                    review: 'Sattva Tech was a great cultural fit with our small team, which was really appreciated on our daily stand-up calls. They are a good communicator, both written and verbal. We hope to work together again in the future!',
                    client: 'Claire J',
                    star: 5,
                    designation: 'CEO',
                },
                {
                    key: '7',
                    review: 'Job was done satisfactorily but if you have a tight schedule it can be a problem. They are flexible, hard working and cooperative and always willing to accommodate requests but need better communication and schedule keeping. I had a good time working with them and will hire them again.',
                    client: 'Paul H',
                    star: 5,
                    designation: 'CEO, ECC',
                },
            ],
            faqData: [
                { question: "What Services does Sattva Tech Offer?", answer: "Our company offers a range of IT services, including software development, IT consulting, web design, cloud services, and IT support." },
                { question: "What industries do you serve?", answer: "We serve a wide range of industries, including healthcare, finance, retail, education, and manufacturing." },
                { question: "How does Sattva Tech Work?", answer: "We follow a agile software development approach, which involves close collaboration with our clients and regular iteration and testing. This helps us deliver high-quality software solutions that meet the evolving needs of our clients." },
                { question: "Do you offer ongoing support and maintenance ?", answer: "Yes, we offer ongoing support and maintenance services to ensure that our software solutions continue to perform at their best and meet the changing needs of our clients." },
            ],
        },

        aboutUsPage: {
            title: 'About us',
            description: 'Our success is rooted in a shared passion for our craft. The strong partnerships we build, both within our team and with our clients, form the foundation of everything we achieve. Together.',
            ReliabilityAboutUsData: [
                {
                    key: 1,
                    image: getImage('ABOUTRESPECT'),
                    title: 'Respect',
                    subtitle: 'Our goal at Sattva Tech is to maintain a stress-free environment where creative professionals can work together as a team, honing their skills, enjoying what they do, & pursuing their ambitions.',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
                {
                    key: 2,
                    image: getImage('ABOUTHANDSHAKE'),
                    title: 'Commitment',
                    subtitle: 'We invest our skills and energy into the organization, so we can reap the benefits together.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 3,
                    image: getImage('ABOUTCHAT'),
                    title: 'Honest Communication',
                    subtitle: 'We embrace open-minded conversations, offering frank opinions and feedback to each other.',
                    bgColor: '#842CFF',
                    color: 'purple'
                },
                {
                    key: 4,
                    image: getImage('ABOUTGOODLUCK'),
                    title: 'Keeping Promises',
                    subtitle: 'We fulfil every commitment with trust, reliability, and genuine kindness that guides our actions. Keeping our word means caring for those we work with.',
                    bgColor: '#FFB912',
                    color: 'yellow'
                },
                {
                    key: 5,
                    image: getImage('ABOUTMOTIVATION'),
                    title: 'Passion',
                    subtitle: 'If it’s not a dream job, it’s not a job worth having. Our craft is something we hold sacred, and every day spent mastering the craft is a day well lived.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
                {
                    key: 6,
                    image: getImage('ABOUTPEOPLE'),
                    title: 'Connection',
                    subtitle: 'We form bonds with each other, taking remote work to a whole new level. Be it VR activities or travelling across the globe, we do it together.',
                    bgColor: '#98FF12',
                    color: 'green'
                },
            ],
        },

        careerPage: {
            title: 'Career and Culture at Sattva Tech',
            description: 'It’s an operational success for us with a united team by our side. Together, we work hard, cater solution, brainstorm non stop, leisure travel and so much more. ',
            JobPositions: [
                {
                    key: 1,
                    image: getImage('NODEJS'),
                    title: 'Digital Marketer',
                    experience: 'Fresher',
                    vacancy: '3',
                    city: 'surat'
                },
                {
                    key: 2,
                    image: getImage('NODEJS'),
                    title: 'Node js developer',
                    experience: '3+ Years',
                    vacancy: '2',
                    city: 'surat'
                },
                {
                    key: 3,
                    image: getImage('WEB3'),
                    title: 'Web3 & BlockChain developer',
                    experience: 'Fresher',
                    vacancy: '2',
                    city: 'surat'
                },
                {
                    key: 4,
                    image: getImage('WEB3'),
                    title: 'BDE Remote',
                    experience: '3+ Years',
                    vacancy: '2',
                    city: 'surat'
                },
            ],
            ReliabilityCareerData: [
                {
                    key: 1,
                    image: getImage('CAREERCOMPANY'),
                    title: 'Fast growing company',
                    subtitle: 'We are at an inflection point to achieve accelerated.',
                },
                {
                    key: 2,
                    image: getImage('CAREERCOLLEAGUE'),
                    title: 'Great Colleagues',
                    subtitle: 'Closely tied and supportive team.',
                },
                {
                    key: 3,
                    image: getImage('CAREERCHARGE'),
                    title: 'Take Charge',
                    subtitle: 'As much as you are willing to take and show excellence.',
                },

                {
                    key: 4,
                    image: getImage('CAREERSKULL'),
                    title: 'Don’t stop learning',
                    subtitle: "An atmosphere where learning is always on the to-do list.",
                },
                {
                    key: 5,
                    image: getImage('CAREERTECH'),
                    title: 'Latest technology front',
                    subtitle: 'Font Working experience of cutting edge technologies.',
                },
                {
                    key: 6,
                    image: getImage('CAREERDOMAIN'),
                    title: 'Cross domain exposure',
                    subtitle: 'Highly passionate and cohesive team of technology and business people.',
                },
            ],
        },


        blogPage: {
            title: 'Blogs',
            description: 'Discover the latest trends in IT service such as web application development, mobile app development, custom software development, IT staff augmentation, and UI/UX designing.',

        }
    }

}
export default pageData